import React, {Component} from 'react';
import styled from 'styled-components';
import MarkdownStyle from '../../helpers/MarkdownStyle';
import ReactMarkdown from "react-markdown";

const Wrapper = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
`
class TextBlock extends Component {
  render() {
    const { text, blockNumber } = this.props;
    return (
      <Wrapper>
        <MarkdownStyle data-blocknumber={blockNumber} className='block'>
          <ReactMarkdown source={text} sourcePos={true}/>
        </MarkdownStyle>
      </Wrapper>
    );
  }
}


export default TextBlock;



// WEBPACK FOOTER //
// ./src/book/blocks/TextBlock.js